module.exports = {
  localeName: 'en-GB',
  momentFormat: 'DD/MM/YYYY'
};
